export default {"src":"/_next/static/media/clock_64.1d8cfffb.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};